import TournamentDto from './tournament-dto';
import UserDto from './user-dto';
import UserGroupDto from './user-group-dto';
import { SelectOptionType } from '../../utils/react-table';

export enum MessageType {
    Promotion = 'PromotionPushNotification',
    Article = 'ArticlePushNotification',
}

export enum MessageStatus {
    Draft = 'Draft',
    Scheduled = 'Scheduled',
    Publishing = 'Publishing',
    Published = 'Published',
    Removed = 'Removed',
    Recalled = 'Recalled',
}

export const MessageStatusOptions: SelectOptionType[] = [
    { label: 'Draft', value: MessageStatus.Draft },
    { label: 'Scheduled', value: MessageStatus.Scheduled },
    { label: 'Publishing', value: MessageStatus.Publishing },
    { label: 'Published', value: MessageStatus.Published },
    { label: 'Removed', value: MessageStatus.Removed },
    { label: 'Recalled', value: MessageStatus.Recalled },
];

export const MessageTypeOptions: SelectOptionType[] = [
    { label: 'Promotion', value: MessageType.Promotion },
    { label: 'Article', value: MessageType.Article },
];

export type PromotionMessageDto = {
    description: string;
};

export type ArticleMessageDto = {
    articleEntryId: string;
};

export type MessageTargetDto = {
    // Can be full DTOs (when receiving)
    groups?: UserGroupDto[];
    users?: UserDto[];

    groupIds?: number[]; // IDs only (when sending)
    userIds?: number[]; // IDs only (when sending)
};

export type MessageDto = {
    id: number;
    createdAt: string; // ISO 8601 date string
    modifiedAt: string; // ISO 8601 date string
    publishedAt?: string; // ISO 8601 date string

    createdBy: UserDto;
    lastModifiedBy: UserDto;

    messageTitle: string;
    messageDescription: string;

    promotionMessagePayload?: PromotionMessageDto;
    articleMessagePayload?: ArticleMessageDto;

    messageType: MessageType;
    status: MessageStatus;

    tournament?: TournamentDto;
    messageTarget?: MessageTargetDto;
};

export type MessageLogDto = {
    timestampUTC: Date | string;
    userTrigram: string;
    messageId: number;
    messageStatus: string;
    operationType: string;
    changeData: string;
};
